'use client';
import { useEffect } from 'react';
import { supabase } from '@/lib/supabaseClient';

function getSessionId(): string {
  if (typeof window === 'undefined') return '';
  let id = localStorage.getItem('blog_view_session_id');
  if (!id) {
    id = (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function')
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem('blog_view_session_id', id);
  }
  return id;
}

export function BlogViewTracker({ postId }: { postId: string }) {
  useEffect(() => {
    const sessionId = getSessionId();
    const dedupeKey = `blog_viewed:${postId}:${sessionId}`;
    if (sessionStorage.getItem(dedupeKey)) return;
    sessionStorage.setItem(dedupeKey, '1');
    (supabase as any)
      .from('blog_post_engagement')
      .insert({ post_id: postId, session_id: sessionId, engagement_type: 'view' })
      .then(({ error }: { error: unknown }) => {
        if (error) console.error('Failed to record blog view:', error);
      });
  }, [postId]);

  return null;
}
